export const environment = {
  production: false
};
export const apiUrl = 'https://api.quickmall24.com/api'; 
// 127.0.0.1:7635 in backend-service;  
// using '//backend:9002/api'  in docker-compose.yml 
// using ` minikube service backend-service` to get the backend host.port

